<template>
  <div style="margin-top:0.1rem">
    <div class="add-custom-banner flex-start" style="background:#fff;margin:10rpx 0">
      <div
        class="add-custom-nav"
        v-for="(item,index) in content"
        :key="index"
        @click="onPicClick(item)"
      >
        <img class="add-custom-img" :src="item.pic_url" mode="widthFix" />
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "Pics",
  components: {
    Dialog
  },
  props: {
    content: {
      type: Array,
      default: []
    }
  },

  data: function() {
    return {};
  },

  methods: {
    onPicClick(item) {
      console.log(item);
      rbLink({
        name: item.url.name.substring(0, 1).toUpperCase() + item.url.name.substring(1),
        query: item.url.query
      });
       
    }
  },

  filters: {}
};
</script>

<style scoped>
.add-custom-banner {
  width: 7.1rem;
  display: flex;
  margin: 0 auto;
  justify-content: space-around;
}
.add-custom-nav {
  width: 32%;
}
.add-custom-nav img {
  width: 100%;
  margin: 0 auto;
  display: block;
}
</style>


// WEBPACK FOOTER //
// Pics.vue?655d9796